<style scoped>
.float-divider {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: white;
  padding-left: 12px;
  padding-right: 12px;
}

.divider-container {
  position: relative;
  padding-top: 12px;
  padding-bottom: 12px;
}
</style>

<template lang="pug">
  div(v-if='user')
    .row
      .col.s12
        p.title.small Where should we deliver?
    .row(v-if='addresses.length')
      .col.s12
        p.title.light Choose an existing delivery address
        .input-field
          select(ref='addressSelect' @change='setAddress')
            option(disabled, :selected='!currentAddress') Select an address
            option(v-for='address in addresses', :value='address.id', :selected='currentAddress === address.id' :disabled='!address.name.endsWith(location)') {{address.name}}
      .col.s12.divider-container
        .divider
        span.float-divider Or
    .row
      .col.s12
        p.title.light Add new delivery address
    form
      .row
        .col.s12.m8.input-field
          input#line1(type='text', v-model='address.line1')
          label(for='line1') Address
        .col.s12.m4.input-field
          input#zip(type='text', v-model='address.zipCode')
          label(for='zip') Zip code
      .row
        .col.s12.input-field
          input#location(type='text' v-model='location' disabled)
          label.active(for='location') Location
        .col.s12.right-align
          a.btn.waves-effect(@click='addAddress') Save

    .vspace.medium
  div(v-else)
    p.title.small Almost there!
    p You have to be logged in to set your address
    router-link.indigo-text(:to='{path: "login", query: {redirectUrl: $route.path}}') Log-in or register
</template>
<script>
/* eslint-disable no-undef */
export default {
  name: 'appAddress',
  props: ['onAddressSet'],
  data () {
    return {
      cityAutocomplete: null,
      address: {
        line1: null,
        zipCode: null
      },
      mounted: false,
      citiesLoaded: false
    }
  },
  created () {
    this.initializeAddresses()
  },
  computed: {
    user () {
      return this.$store.state.auth.user
    },
    currentAddress () {
      return !this.$store.state.cart.address
        ? null
        : this.$store.state.cart.address.id
    },
    addresses () {
      return this.$store.getters['customer/friendlyAddresses'] || []
    },
    location () {
      return this.$store.state.cart.location
    },
    '$store.state.customer.addresses' () {
      this.initializeAddresses()
    }
  },
  methods: {
    initializeAddresses () {
      this.$nextTick(() => {
        this.$M.FormSelect.init(this.$refs.addressSelect)
      })
    },
    addAddress () {
      this.$store
        .dispatch('customer/addAddress', {
          ...this.address,
          location: this.location
        })
        .then(address => {
          this.$snackbar.success('Address added')
          this.setAddress({
            target: {
              value: address.id
            }
          })
        })
    },
    setAddress (e) {
      const address = this.$store.getters['customer/getFriendlyAddressById'](
        e.target.value
      )

      this.$store.dispatch('cart/setAddress', address)
      if (typeof this.onAddressSet === 'function') {
        this.onAddressSet(address)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/app-address-setup.vue